import api from "@/services/api";

const { get, post, delete: del } = api.getPrefixedMethods("users");

export default {
  listUsers() {
    return get("");
  },
  inviteUser(email) {
    return post("invite", { email });
  },
  revokeInvite(pk) {
    return del(`${pk}`);
  },
};
